import { generateRandomGuid4 } from './utils';
export function CorrelationId() {
  let _prevCorrelationId = null;
  let _correlationId = null;
  this.get = () => _correlationId;
  this.getPrevious = () => _prevCorrelationId;
  this.set = correlationId => {
    _prevCorrelationId = _correlationId;
    return _correlationId = correlationId;
  };
  this.randomize = () => this.set(generateRandomGuid4());
  this.reset = () => this.set(null);
}